export const site = {
  name: '看料社',
  latin: 'KANLIAOSHE',
  slogan: '把热点看明白，不做一个只会吃瓜的看客。',
  subSlogan: '一档由编辑部持续产出的深扒档案与专栏分析，陪你拆解娱乐与内容行业的热点事件脉络。',
  intro:
    '看料社是一个以编辑部为主导的深度内容栏目平台。我们不做情绪化站队，也不追着热搜做一锤子买卖，而是像做一份报纸的深度版那样，把一条事件的时间线、关键节点、各方声音与背后机制慢慢铺开，帮你在信息过载里理出真正有用的脉络。',
  email: 'bianji@kanliaoshe.example',
  domain: 'https://atba.top',
  authors: ['阿刀', '罐头', '老烟', '灯下'],
};

export type Column = {
  slug: string;
  name: string;
  en: string;
  mark: string;
  desc: string;
  cover: string;
};

export const columns: Column[] = [
  {
    slug: 'shenba',
    name: '深扒档案',
    en: 'DeepDive',
    mark: 'D·D',
    desc: '围绕热点事件与网络现象逐层拆解，把被滤镜、断章与节奏盖住的细节重新放回桌上，还原最接近事实的脉络。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20investigative%20folder%20and%20archive%20scene%20with%20magnifying%20glass%2C%20torn%20clippings%20and%20red%20tape%20notes%20on%20warm%20paper%20desk%2C%20muted%20crimson%20and%20ochre%20tones%2C%20moody%20tungsten%20desk%20lamp%2C%20documentary%20journalism%20aesthetic%2C%20textured%20linen%20background%2C%20film%20grain%2C%20high%20detail&width=1200&height=800&seq=col-shenba&orientation=landscape',
  },
  {
    slug: 'maolu',
    name: '脉络专栏',
    en: 'Context',
    mark: 'C·T',
    desc: '把纷杂的信息整理成清晰的时间线与节点图谱，标注每一处"发生了什么、由谁推动、何时转折"，帮你看懂来龙去脉。',
    cover:
      'https://readdy.ai/api/search-image?query=Timeline%20of%20pinned%20newspaper%20articles%20connected%20by%20thin%20red%20thread%20on%20warm%20corkboard%2C%20chronological%20research%20wall%20with%20date%20stickers%20and%20handwritten%20notes%2C%20warm%20amber%20desk%20light%2C%20ochre%20and%20charcoal%20palette%2C%20editorial%20documentary%20style%2C%20soft%20depth%20of%20field%2C%20detailed%20texture&width=1200&height=800&seq=col-maolu&orientation=landscape',
  },
  {
    slug: 'muhou',
    name: '幕后再探',
    en: 'Backstage',
    mark: 'B·S',
    desc: '拆解内容生产、宣发节奏、粉丝与评论生态背后的运行机制，看一张热度表是如何被一支支看不见的手推动成形。',
    cover:
      'https://readdy.ai/api/search-image?query=Backstage%20production%20room%20with%20clapperboard%2C%20scripts%2C%20monitor%20glow%20and%20scheduling%20boards%2C%20warm%20tungsten%20lighting%20against%20deep%20brown%20shadows%2C%20editorial%20behind%20the%20scenes%20aesthetic%2C%20vintage%20film%20camera%20silhouettes%2C%20muted%20rust%20and%20gold%20palette%2C%20atmospheric%20cinematic%20depth&width=1200&height=800&seq=col-muhou&orientation=landscape',
  },
  {
    slug: 'fangfa',
    name: '看料方法论',
    en: 'Method',
    mark: 'M·D',
    desc: '编辑部把多年看料经验沉淀成方法：先辨信源、再理时间、后查动机。教你像编辑一样读信息，少被节奏带偏。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20handbook%20with%20step%20numbered%20list%2C%20checklist%2C%20pen%20and%20notebook%20on%20warm%20paper%2C%20magnifying%20glass%20and%20red%20underlines%2C%20muted%20crimson%20and%20ochre%20accents%2C%20flat%20lay%20editorial%20study%20style%2C%20cream%20linen%20background%2C%20refined%2C%20detailed%20texture&width=1200&height=800&seq=col-fangfa&orientation=landscape',
  },
];

export const columnMap = Object.fromEntries(columns.map((c) => [c.slug, c]));